export default function SetUsersList(data) {
  return {
    type: 'USERS_LIST',
    data,
  };
}
